module.exports = __webpack_public_path__ + "img/0x2d4c6cf0417209a7eb410160344e224e74f87195.6976c626.png";